/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Loan: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <g clipPath='url(#clip0_20400_927)'>
      <path
        d='M20 16H16.7C16.8657 16.6579 16.955 17.3327 16.966 18.011C16.9631 18.2743 16.8565 18.5258 16.6692 18.711C16.482 18.8962 16.2293 19 15.966 19H7V17H15C15 15.9391 14.5786 14.9217 13.8284 14.1716C13.0783 13.4214 12.0609 13 11 13H7C5.8 11.289 3.305 11 2.1 11H0V19.5L8.192 23.263C9.19998 23.7665 10.3631 23.8625 11.44 23.531L24 19.667C24 19.667 23.208 16 20 16Z'
        fill='currentColor'
      />
      <path
        d='M15 0C13.8133 0 12.6533 0.351894 11.6666 1.01118C10.6799 1.67047 9.91085 2.60754 9.45673 3.7039C9.0026 4.80026 8.88378 6.00666 9.11529 7.17054C9.3468 8.33443 9.91825 9.40353 10.7574 10.2426C11.5965 11.0818 12.6656 11.6532 13.8295 11.8847C14.9933 12.1162 16.1997 11.9974 17.2961 11.5433C18.3925 11.0892 19.3295 10.3201 19.9888 9.33342C20.6481 8.34673 21 7.18669 21 6C20.9984 4.40919 20.3658 2.88399 19.2409 1.75911C18.116 0.63424 16.5908 0.00158843 15 0V0ZM16 9H14V3H16V9Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_20400_927'>
        <rect width='24' height='24' fill='currentColor' />
      </clipPath>
    </defs>
  </React.Fragment>
)
